import { c as _c } from "react/compiler-runtime";
import { useEffectiveThemeMode } from "@hooks/use-effective-theme-mode";
import { useEffect } from "react";

/** Component that applies dark mode styling to the document root */
export function DarkModeApplier() {
  const $ = _c(3);
  const isDarkModeEnabled = useEffectiveThemeMode() === "dark";
  let t0;
  let t1;
  if ($[0] !== isDarkModeEnabled) {
    t0 = () => {
      const root = document.documentElement;
      if (isDarkModeEnabled) {
        root.setAttribute("data-dark-mode", "true");
      } else {
        root.removeAttribute("data-dark-mode");
      }
    };
    t1 = [isDarkModeEnabled];
    $[0] = isDarkModeEnabled;
    $[1] = t0;
    $[2] = t1;
  } else {
    t0 = $[1];
    t1 = $[2];
  }
  useEffect(t0, t1);
  return null;
}